import HasID from "./HasID";
import TrackedObject from "./TrackedObject";
import { Contact } from "./Contact";
import { FunctionalityFlag } from "./FunctionalityFlag";
import { PriceSchedule } from "./PriceSchedule";
import { Prescriber } from "./Prescriber";
import { DeliveryCode } from "./DeliveryCode";
import { DrugProgram } from "@/models/Drug/Drug";
import HasLabel from "./HasLabel";
import { OrderAuditConfiguration } from "@/models/OrderAudit";
import { TextMessageTemplates } from "./TextMessageTemplates";
import { InventoryLocation } from "./InventoryLocation";
import { PharmacyRecord } from "./Pharmacy";
import { Team } from "@/models/Team";
import { DoctorFollowUpNextTouch, PriorAuthNextTouch } from "./PriorAuthorization";
import { EmailTemplates } from "@/models/EmailTemplates";
import { FaxTemplateOverride } from './Configuration';

export interface Program extends HasID, TrackedObject {
    id: number;
    name: string;
    abbreviation: string;
    memo: string;
    active: boolean;
    forceMemo: boolean;
    autoprocess: boolean;
    customTemplateFileId: number;
    programContact: Contact;
    businessContact: Contact;
    deliveryMethod?: DeliveryCode;
    priceSchedule: PriceSchedule | null;
    priceScheduleId: number | null;
    flags: FunctionalityFlag[];
    customTemplate?: File;
    customTemplateUpdated: Date;
    drugs?: Array<DrugProgram>;
    prescribers?: Array<Prescriber>;
    auditChance: number;
    apiKey: string;
    priceAdjustment: number | null;
    orderAuditConfigurations?: Array<OrderAuditConfiguration>;
    carriers: string[];
    textMessageTemplates: TextMessageTemplates;
    emailTemplates: EmailTemplates;
    defaultFillingLocation: InventoryLocation;
    userTaskSLADays: number;
    userTaskDefaultTeamId?: number;
    userTaskWebhookEndpoint?: string;
    transferToPharmacies?: Array<PharmacyRecord>;
    teams: Team[];
    doctorFollowUpNextTouchDays: DoctorFollowUpNextTouch[];
    priorAuthNextTouchDays: PriorAuthNextTouch[];
    papNextTouchDays: any[];
    awaitingInsuranceHours?: number;
    faxTemplateOverrides?: Record<string, FaxTemplateOverride>;
}

export class Program extends HasLabel {
    constructor(obj?: Program) {
        super();
        this.id = 0;
        // this.priceAdjustment = 1;
        this.flags = new Array<FunctionalityFlag>();
        this.teams = [];
        if (obj) {
            Object.assign(this, obj);
            if (obj.teams) {
                this.teams = obj.teams.map(t => new Team(t));
            }
        }

        if (!this.textMessageTemplates) {
            this.textMessageTemplates = new TextMessageTemplates();
        }

        if (!this.emailTemplates) {
            this.emailTemplates = new EmailTemplates();
        }

        if (!this.defaultFillingLocation) {
            this.defaultFillingLocation = new InventoryLocation();
        }

        if (!this.doctorFollowUpNextTouchDays) {
            this.doctorFollowUpNextTouchDays = [];
        }

        if (!this.priorAuthNextTouchDays) {
            this.priorAuthNextTouchDays = [];
        }

        if (!this.papNextTouchDays) {
            this.papNextTouchDays = [];
        }

        if (!this.faxTemplateOverrides) {
            this.faxTemplateOverrides = {};
        }
    }

    toString(): string {
        if (this.name) {
            return `Program - Abbr: ${this.name} - ${this.abbreviation || ''}`;
        } else {
            return '<div class="font-weight-light">Name</div>';
        }
    }

}
